export default __webpack_public_path__ + "static/media/2206.53f382e3.png";